// extracted by mini-css-extract-plugin
export var contentBody = "_db-9";
export var headerImage = "_db-2";
export var imageButton = "_db-7";
export var imageButtonIcon = "_db-8";
export var imageHeader = "_db-4";
export var imageHeaderText = "_db-5";
export var imageOverlay = "_db-3";
export var imageTitle = "_db-6";
export var imageWrapper = "_db-1";
export var taskList = "_db-a";
export var widget = "_db-0";